import styled from 'styled-components';
import Drawer from 'components/Drawer';
import { GREY_300, GREY_500, GREY_800 } from '../../constants';

export const SearchContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    padding: 1rem;
`;
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-self: stretch;
    width: 100%;
    height: 100%;
`;

export const Header = styled.div`
    display: flex;
    align-self: stretch;
    justify-content: space-between;
    align-items: center;
    z-index: 8;
    padding: 1.5rem;
`;

export const Title = styled.h1`
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0;
`;

export const TableContainer = styled.div`
    padding: 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow: auto;
    height: 100%;
`;

export const ReminderDetails = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 1.5rem 1.5rem;
    gap: 1.5rem;
`;

export const ReminderHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0.5rem 0 1rem;
`;

export const ReminderSection = styled.section`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding-bottom: 1rem;
`;

export const ReminderSectionTitle = styled.h2`
    font-size: 1.125rem;
    font-weight: 600;
    color: ${GREY_800};
    margin: 0;
    padding-bottom: 0.5rem;
`;

export const ReminderInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;

export const DetailLabel = styled.span`
    font-size: 0.875rem;
    font-weight: 600;
    color: ${GREY_500};
    letter-spacing: 0.5px;
    margin-bottom: 0.25rem;
`;

export const DetailValue = styled.div`
    font-size: 1rem;
    color: ${GREY_300};
    word-break: break-word;
    line-height: 1.5;
    font-weight: 200;
    letter-spacing: 0.25px;
    
    /* Ensure nested DateTimeColumn components display properly */
    > div {
        padding: 0;
    }
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 2rem 1rem 1rem 1.25rem;
    height: fit-content;
    z-index: 1;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 40%);
    margin-top: -2rem;
`;

export const EntriesText = styled.span`
    font-size: 0.8125rem;
    font-weight: 300;
    line-height: 1.25rem;
    color: ${GREY_300};
`;

export const PaginationButtons = styled.div`
    display: flex;
    gap: 0.25rem;
    align-items: center;
    justify-content: flex-end;
`;

export const StyledDrawer = styled(Drawer)`
    width: 400px;

    div[id^=drawer-content] {
        padding: 1rem 1.5rem;
    }
`;

export const DrawerFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
`;
